import { useParams } from "react-router-dom";
import ReviewsClient from "../../components/reviews/ReviewsClient";
import { normalizeLocale } from "../../utils/locales";

export default function ReviewsPage() {
  const { locale } = useParams();
  const loc = normalizeLocale(locale);
  return <ReviewsClient locale={loc} />;
}
